module.exports = __webpack_public_path__ + "img/eyeblue.7161f051.svg";